module.exports = __webpack_public_path__ + "img/qkrz.f5121460.png";